import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, addedGroupAction } from '../../reducers/actions';
import { GroupService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_GROUP),
    switchMap(action =>
      GroupService.create(action.group, store).pipe(
        map(data => addedGroupAction(data)),
        catchError(retryAuthentication(action$, 'epics/groups/addGroup'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/groups/addGroup.js